export const AuthorisationRoutes = {
  NoAccess: '/no-access',
};
